import { createAsyncThunk } from "@reduxjs/toolkit";
import { blockUser, fetchUserList } from "../../services/user.service";
import { enqueueSnackbar } from "notistack";

export const doFetchUserList = createAsyncThunk(
  "user/fetchUserList",
  async (payload: any) => {
    try {
      const response: any = await fetchUserList({
        userType: payload.userType,
        page: payload.page,
        limit: payload.limit,
      });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to fetch user list";
      enqueueSnackbar(errorMessage, { variant: "error" });
      throw errorMessage;
    }
  }
);

export const doBlockUser = createAsyncThunk(
  "user/blockUser",
  async (id: string) => {
    try {
      const response: any = await blockUser(id);
      enqueueSnackbar(response.message, { variant: "success" });
      return response;
    } catch (error: any) {
      const errorMessage =
        error.response?.data?.message || "Failed to block/unblock user";
      enqueueSnackbar(errorMessage, { variant: "error" });
      throw errorMessage;
    }
  }
);
